import { createFileRoute, Outlet } from "@tanstack/react-router";
import { meQuery, workspaceQuery } from "@/lib/api/queries";

export const Route = createFileRoute("/w/$workspace")({
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.ensureQueryData(meQuery()),
      context.queryClient.ensureQueryData(workspaceQuery(params.workspace)),
    ]),
  component: () => <Outlet />,
});
